import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { TopographicLines } from "../components/TopographicLines";
import { usePublishedPosts } from "../components/JournalSection";
import { useI18n } from "../i18n";
import { formatPublicationDate } from "../lib/date";

export function JournalIndexPage() {
  const { locale, messages } = useI18n();
  const { posts, pending, failed } = usePublishedPosts();
  const copy = messages.blog;

  return (
    <>
      <Header />
      <main className="journal-page">
        <section className="page-hero page-hero--journal">
          <TopographicLines className="page-hero__contours" />
          <div className="shell page-hero__inner">
            <div>
              <h1>{copy.index.title}</h1>
              <p>{copy.index.intro}</p>
            </div>
            <div className="journal-principle">
              <strong>{copy.index.ruleLabel}</strong>
              <p>{copy.index.ruleBody}</p>
            </div>
          </div>
        </section>
        <section className="journal-list section">
          <div className="shell">
            {posts.length === 0 ? (
              <p className="journal-preview__status" role="status">
                {failed
                  ? copy.preview.unavailable
                  : pending
                    ? copy.article.loading
                    : copy.preview.empty}
              </p>
            ) : (
              <div aria-busy={pending}>
                {posts.map((post, index) => (
                  <article className="journal-list__item" key={post.slug}>
                    <p className="journal-list__number">
                      {String(index + 1).padStart(2, "0")}
                    </p>
                    <Link
                      className="journal-list__media"
                      to={`/journal/${post.slug}`}
                      tabIndex={-1}
                      aria-hidden="true"
                    >
                      <img
                        src={post.heroImage.src}
                        alt=""
                        width="1536"
                        height="1024"
                        loading={index === 0 ? "eager" : "lazy"}
                      />
                    </Link>
                    <div>
                      <p className="story-card__meta">
                        {copy.categories[post.category] ?? post.category} ·{" "}
                        {copy.common.minutes(post.readingMinutes)} ·{" "}
                        {formatPublicationDate(post.publishedAt, "long", locale)}
                      </p>
                      <h2>
                        <Link to={`/journal/${post.slug}`}>{post.title}</Link>
                      </h2>
                      <p>{post.excerpt}</p>
                    </div>
                    <Link
                      className="journal-list__arrow"
                      to={`/journal/${post.slug}`}
                    >
                      <span>{copy.index.read}</span>
                      <ArrowRight aria-hidden="true" />
                    </Link>
                  </article>
                ))}
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
